import { number, object } from "yup";

export const validationMap = {
  PurchaseIrqCreditScorePage: object().shape({
    creditScore: number()
      .typeError("Provided value is invalid")
      .positive()
      .integer()
      .max(850, "Credit score must be 850 or lower")
      .min(620, "Credit score must be 620 or higher")
      .required(""),
  }),
  RefinanceIrqCreditScorePage: object().shape({
    creditScore: number()
      .typeError("Provided value is invalid")
      .positive()
      .integer()
      .max(850, "Credit score must be 850 or lower")
      .min(620, "Credit score must be 620 or higher")
      .required(""),
  }),
  BuildIrqCreditScorePage: object().shape({
    creditScore: number()
      .typeError("Provided value is invalid")
      .positive()
      .integer()
      .max(850, "Credit score must be 850 or lower")
      .min(620, "Credit score must be 620 or higher")
      .required(""),
  }),
};
